export const removeToken = (value: string): string =>
  value.replace(/Bearer [^"]*/g, 'Bearer: <TOKEN>')
